import { createFileRoute, Navigate } from "@tanstack/react-router";
import { useAuth } from "../lib/auth-context.js";

/**
 * `/` — root redirect. Auth context decides:
 *   loading → splash
 *   anon    → /login
 *   authed  → / (dashboard home placeholder)
 */
export const Route = createFileRoute("/")({
  component: IndexRoute,
});

function IndexRoute() {
  const { status } = useAuth();
  if (status === "loading") {
    return (
      <main style={{ padding: 96, textAlign: "center" }}>Loading…</main>
    );
  }
  if (status === "anon") return <Navigate to="/login" />;
  return <Navigate to="/dashboard" />;
}
